import { render, staticRenderFns } from "./ScheduleMatrixHours.vue?vue&type=template&id=54eb48f5&scoped=true"
import script from "./ScheduleMatrixHours.vue?vue&type=script&lang=js"
export * from "./ScheduleMatrixHours.vue?vue&type=script&lang=js"
import style0 from "./ScheduleMatrixHours.vue?vue&type=style&index=0&id=54eb48f5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54eb48f5",
  null
  
)

export default component.exports